import { PAX_LOADING, PAX_FAILED, PAX_SUCCESS } from "../types"

const initialState = {
  loading: false,
  error: false,
  paxes: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case PAX_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        paxes: null,
      }
    case PAX_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        paxes: null,
      }
    case PAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        paxes: action.payload,
      }
    default:
      return state
  }
}
